// extracted by mini-css-extract-plugin
export default {"title":"TransferPage_title__569yp","slides":"TransferPage_slides__CrXo4","slide":"TransferPage_slide__Q7sZ4"};